import React, { useState, useCallback } from 'react';
import Datepicker from 'components/actions/DatePicker';
import AnalyticsSerive from 'api/services/AnalyticsService';
import LayoutWrapper from 'components/LayoutWrapper';
import { useTranslation } from "react-i18next";
import { getChannelLanguageString, getDateRangeString, getI18nValue, tailwindConfig } from 'utils/Utils';
import BarChart from 'charts/HorizontalBarChart';
import { ExportCSV } from 'components/ExportCSV';
import { useAxios } from 'hooks/useAxios';
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';

function TrainStationsOverview() {

    const { t } = useTranslation();

    const [selectedDateRanges, setSelectedDateRanges] = useState(
        {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            key: 'selection',
        }
    );

    const [channel, setChannel] = useState('');
    const [language, setLanguage] = useState('');

    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setSelectedDateRanges(newRanges), []);

    const [data, error, loading] = useAxios(AnalyticsSerive.getOriginDestinaion(selectedDateRanges, channel, language))


    return (

        <div className='p-4 col-span-full sm:col-span-full xl:col-span-full bg-white shadow-sm rounded-sm border border-gray-200 min-h-[480px] flex flex-col'>
            <div className="sm:flex sm:justify-between sm:items-center border-b border-gray-100 mb-4">
                <div className='mb-4'>
                    <header className='capitalize text-xl font-semibold text-gray-800 '>{t(getI18nValue('analytics.origin_destination', "title"))}</header>
                    <p className='text-sm font-light'>{t(getI18nValue('analytics.origin_destination', "description"))}</p>
                </div>

                <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                    <ExportCSV csvData={data} disabled={!data} fileName={`top_20_od_${getDateRangeString(selectedDateRanges) + getChannelLanguageString(channel, language)}`} />
                    <ChannelSelect value={channel} onChange={setChannel} />
                    <LanguageSelect value={language} onChange={setLanguage} />
                    <Datepicker callBack={handleDateChange} />
                </div>
            </div>
            <LayoutWrapper error={error} loading={loading} variant="chart" isEmpty={!loading && !data} className="flex-1 min-h-0">
                <BarChart
                    data={
                        {
                            labels: data?.od,
                            datasets: [
                                {
                                    label: t(getI18nValue('analytics.origin_destination', "od_axis")),
                                    data: data?.counts,
                                    backgroundColor: tailwindConfig().theme.colors.blue[400],
                                    hoverBackgroundColor: tailwindConfig().theme.colors.gray[800],
                                    barPercentage: 1,
                                    categoryPercentage: 0.7,
                                },
                            ]
                        }
                    }
                />
            </LayoutWrapper>

        </div >

    );
}

export default TrainStationsOverview;


